import { MenuItem, Select, Stack, TextField } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { alert } from "src/services/alert";
import UserInfo from "src/components/common/UserInfo";
import FormDialog from "src/components/common/FormDialog";
import FormItem from "src/components/form-item/FormItem";
import { asyncRequest } from "src/services/network";
import { USER_LEVELS, USER_LEVEL_MAP } from "src/config/constants";


const levels = Object.values(USER_LEVELS);

const ChangeUserLevelDialog = ({ user, open, onFinish, onClose }) => {

  const [form, setForm] = useState({
    level: user.level,
    remark: ''
  });

  console.log(form, user)

  useEffect(() => {
    if (!user.pid) return;
    // getUserParent();
  }, [])


  function handleIptChange(ki, val) {
    setForm({
      ...form,
      [ki]: val,
    });
  }

  async function handleDialogConfirm() {
    if (form.level == undefined) return alert('请选择等级');

    const { msg } = await asyncRequest({
      path: "/user/changeLevel",
      data: {
        ...form,
        uid: user.uid,
      },
    });

    setForm({
      nickname: "",
    });
    alert(msg, "success");
    onClose();
    onFinish();
  }

  return (
    <FormDialog title="修改商城等级" open={open} onClose={onClose} onConfirm={handleDialogConfirm}>
      <FormItem title="用户" required>
        <Stack direction="row" alignItems="center" spacing={2}>
          <UserInfo {...user} enablePreview={false} />
        </Stack>
      </FormItem>

      <FormItem title="等级" required>
        <Select
          value={form.level}
          onChange={(e) => handleIptChange("level", e.target.value)}
          style={{ width: 250, height: 44 }}
        >
          {levels.map((level, idx) => (
            <MenuItem key={idx} value={level} name={level}>
              {USER_LEVEL_MAP[level]}
            </MenuItem>
          ))}
        </Select>
      </FormItem>

      <FormItem title="备注">
        <TextField fullWidth value={form.remark} size="small" onChange={(e) => handleIptChange("remark", e.target.value)} rows={4} multiline />
      </FormItem>
    </FormDialog>
  );
};

export default ChangeUserLevelDialog;
